/**
 * レーダ画像
 */
import Repository from "./Repository";
import Util from "./../lib/util";

const resource = "";
const timeFormat = "YYYY-MM-DD HH:mm";

export default {
  /**
   * レーダ画像情報取得
   * @param time 対象日時
   * @param type レーダ種別
   * @param level 地域レベル
   */
  getRadarInfo(time, type, level) {
    let param = "/" + Util.formatDate(time, timeFormat) + "/" + level;
    if (type == "xrain") {
      return Repository.get(`${resource}/radar/xrainArea` + param);
    } else {
      return Repository.get(`${resource}/radar/cbandArea` + param);
    }
  },

  /**
   * レーダ観測日時取得
   * @param time 対象日時
   */
  getRadarDate(time) {
    let param = "/" + Util.formatDate(time, timeFormat);
    return Repository.get(`${resource}/radar/date` + param);
  },
};
